import * as Models from '../models/index';

export class GeneralRoutesConfig {
    static general: Models.CM.KeyValue = {
        uiKit: 'ui-kit',
        notFound: 'not-found',
        notValidPage: 'not-valid-page',
        accessDeniedPage: 'access-denied'
    };
}
